<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<script setup>
import { ref } from 'vue';

const showInfo = ref(false);

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

function toggleInfo() {
  const wrapper = document.getElementById(`wrapper-${props.title}${props.index}`);
  wrapper.style.maxHeight = showInfo.value ? 'none' : 0;
}
</script>

<template>
  <div class="moreInfo mt-3">
    <div
      :id="`wrapper-${title}${index}`"
      class="content"
    >
      <div :id="`expand-${title}${index}`">
        <slot />
      </div>
    </div>
    <span
      class="moreInfo--toggle d-flex justify-content-center link"
      @click.prevent="(showInfo = !showInfo), toggleInfo()"
    >
      <span v-if="!showInfo">
        + <u>{{ $t('general.moreInfo') }}</u>
      </span>
      <span v-else>
        - <u>{{ $t('general.lessInfo') }}</u>
      </span>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.content {
  -moz-transition: 0.3s;
  -ms-transition: 0.3s;
  -o-transition: 0.3s;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  max-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    background-color: #ffffff;
  }
}

.moreInfo {
  padding: 1.5rem;
  margin: -1.6rem -1.6rem;
  border-bottom-left-radius: 1rem 1rem;
  border-bottom-right-radius: 1rem 1rem;

  @media (min-width: 768px) {
    background-color: var(--theme-font-color-25);
  }

  @media (max-width: 768px) {
    padding: 0 1.5rem 0 1.5rem;

    &--toggle {
      padding: 1.5rem;
      background-color: var(--theme-font-color-25);
      border-bottom-left-radius: 1rem 1rem;
      border-bottom-right-radius: 1rem 1rem;
    }
  }
}

.link {
  font-family: var(--font-medium);
  color: var(--theme-font-color-100);

  &:hover {
    cursor: pointer;
  }
}
</style>
